export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fe6b50f93295610b2726ba7c61627e24db32b8c85&name=fetchTypeahead!'